import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api",
  timeout: 30000,
  timeoutErrorMessage: "time out",
  header: {
    "Content-Type": "application/json",
  },
});

const getUserSubmitions = async (userId) => {
  return apiClient.get(`user/submitions/${userId}`);
};

const create = async (data) => {
  return apiClient.post("user/", data);
};

const verifyUserOTP = async (data) => {
  return apiClient.post("/user/verify", data);
};

export const userService = {
  getUserSubmitions,
  create,
  verifyUserOTP,
};
